import { render, staticRenderFns } from "./CeisaPpjkCreate.vue?vue&type=template&id=354b04d3&scoped=true&"
import script from "./CeisaPpjkCreate.vue?vue&type=script&lang=js&"
export * from "./CeisaPpjkCreate.vue?vue&type=script&lang=js&"
import style0 from "./CeisaPpjkCreate.vue?vue&type=style&index=0&id=354b04d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b04d3",
  null
  
)

export default component.exports